export enum PATHS {
  splash_screen = 'SPLASH_SCREEN',
  login = '/login',
  forgot_password = '/forgot-password',
  confirm_email = '/confirm-email',
  create_password = '/password-set',
  recovery_password = '/password-reset',
  restore = '/restore',
  select_provider = '/select-provider',
  edit = 'EDIT',
  main = '/',
  availability = '/availability',
  users = '/users',
  settings = '/settings',
  settingsCourses = '/settings/courses',
  settingsGroups = '/settings/groups',
  settingsJournals = '/settings/journals',
  profile = '/profile',
  no_shops = '/no-shops',
  dashboard = '/dashboard',
  communicator = '/communicator',
  debtors = '/debtors',
  contributions = '/debtors/contributions',
  debtorsPandadoc = '/debtors/pandadoc',
  debtorsPandadocProvisioning = '/debtors/pandadoc/provisioning',
  debtorsPandadocProvisioningFolder = '/debtors/pandadoc/provisioning/:folderUuid',
  journal = '/journal',
  finances = '/finances',
  financesDashboard = '/finances/dashboard',
  financesInvoices = '/finances/invoices',
  financesInvoice = '/finances/invoices/:id',
  financesExpenses = '/finances/expenses',
  financesExpense = '/finances/expenses/:id',
  financesExpenseNew = '/finances/expenses/new',
  financesPaymentCalendar = '/finances/calendar',
  monitoring = '/monitoring',
  default = '/debtors',
  students = '/students',
  studentDetail = '/students/:id/details',
  teachers = '/teachers',
  teacherDetail = '/teachers/:id/details',
  groupDetail = '/settings/groups/:id/details',
  teachersUsers = '/teachers/users',
  teachersApplications = '/teachers/applications',
  performance = '/performance',
  zoom = '/zoom',
  zoomDashboard = '/zoom/dashboard',
  zoomLessons = '/zoom/lessons',
  zoomLesson = '/zoom/lessons/:id',
  zoomRecordings = '/zoom/recordings',
  zoomRecording = '/zoom/recordings/:id',
  zoomMatching = '/zoom/matching',
  zoomRecent = '/zoom/recent',
  zoomAccounts = '/zoom/accounts',
  zoomSchedule = '/zoom/schedule',
  zoomAudit = '/zoom/audit',
  whiteboardLesson = '/whiteboard/lesson/:id',
  surveys = '/surveys',
  surveyNew = '/surveys/new',
  surveyEdit = '/surveys/:id',
  surveyResults = '/surveys/assignments/:assignmentId/results',
  careerCenter = '/career-center',
}

export function getAuthPath(path: string = '') {
  return `${path}`;
}

export enum PATHS_PARAMS {
  contributionNum = ':contributionNum',
}
